/**
 * How many catalogue writes are in flight.
 *
 * The CMS re-reads the catalogue when the tab becomes visible again. A re-read
 * racing a save could show a row that is about to change, so the re-read stands
 * down while a write is in flight. A module counter, not React state: the value
 * is written and read inside async handlers and the visibility effect, and a
 * render-time value would be stale by the time a promise settles.
 */

let inFlight = 0;

export function beginSave(): void {
  inFlight += 1;
}

export function endSave(): void {
  inFlight = Math.max(0, inFlight - 1);
}

export function savesInFlight(): boolean {
  return inFlight > 0;
}

/** Run a catalogue write, keeping the counter honest whatever it settles with. */
export function trackSave<T>(run: () => Promise<T>): Promise<T> {
  beginSave();
  return run().finally(endSave);
}
